<template>
	<ul class="schedule-recent-list">
		<li
			class="schedule-recent-list__item"
			v-for="item in items"
			:key="item.id"
		>
			<EnvironmentScheduleCard :environment="item" />
		</li>
	</ul>
</template>

<script>
import EnvironmentScheduleCard from '@/sections/environment/schedule/environment-schedule-card.vue';

export default {
	name: 'EnvironmentScheduleList',
	components: {
		EnvironmentScheduleCard
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
/**
	* Schedule Recent Card List
	* Can use SCSS variables = TRUE
*/

.schedule-recent-list {
	display: flex;
	flex-direction: column;
	gap: $gutter-lg;
}
</style>
